var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.78 17.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e73b4c;}.cls-2{fill:#455ba6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "picto_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2,4.1H1a1,1,0,1,1,0-2H2A.15.15,0,0,0,2.12,2V1a1,1,0,0,1,2,0V2A2.14,2.14,0,0,1,2,4.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.26,15,2,14.9V5.77a1,1,0,0,0-2,0V14.9A2.06,2.06,0,0,0,2.06,17h5.2a1,1,0,0,0,0-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.44,0H5.8a1,1,0,0,0-1,1,1,1,0,0,0,1,1l5.7.07V8.8a1,1,0,0,0,2,0V2.07A2.07,2.07,0,0,0,11.44,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.71,4.79H4.18a1,1,0,1,0,0,2H8.71a1,1,0,0,0,0-2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.44,9.25a1,1,0,1,0,0-2H4.18a1,1,0,1,0,0,2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.5,11a3.29,3.29,0,1,0,3.28,3.28A3.29,3.29,0,0,0,12.5,11Zm0,5.57a2.29,2.29,0,1,1,2.28-2.29A2.3,2.3,0,0,1,12.5,16.54Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.8,13a.48.48,0,0,0-.7,0l-.6.59L11.9,13a.5.5,0,0,0-.71,0,.5.5,0,0,0,0,.7l.6.6-.6.6a.51.51,0,0,0,0,.71.52.52,0,0,0,.71,0l.6-.6.6.6a.52.52,0,0,0,.35.14.5.5,0,0,0,.35-.85l-.59-.6.59-.6A.48.48,0,0,0,13.8,13Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoDelete);
export default __webpack_public_path__ + "static/media/pictoDelete.ca6e061a2abc8f4a2dab5dd15e2c8d22.svg";
export { ForwardRef as ReactComponent };